import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const Stars: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M5.444 14.714a.68.68 0 0 1-1.267 0l-.901-2.435a.67.67 0 0 0-.399-.399l-2.435-.901a.68.68 0 0 1 0-1.268l2.435-.901a.67.67 0 0 0 .399-.399l.901-2.435a.68.68 0 0 1 1.267 0l.901 2.435a.67.67 0 0 0 .399.399l2.435.901a.68.68 0 0 1 0 1.268l-2.435.901c-.185.069-.331.214-.399.399l-.901 2.435zm7.454-7.253a.34.34 0 0 1-.634 0l-.724-1.957a.34.34 0 0 0-.2-.2L9.383 4.58a.34.34 0 0 1 0-.634l1.957-.724a.34.34 0 0 0 .2-.2l.724-1.957a.34.34 0 0 1 .634 0l.724 1.957a.34.34 0 0 0 .2.2l1.957.724a.34.34 0 0 1 0 .634l-1.957.724a.34.34 0 0 0-.2.2l-.724 1.957z" />
    </svg>
  );
};

export { Stars };
